import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './ClientTabBar.css';

/**
 * Barra de abas fixa no rodapé do ambiente do cliente, no estilo de um aplicativo: Agendar,
 * Meus agendamentos e Clube. Fica em todas as telas públicas do cliente para ele nunca precisar
 * de um link avulso para trocar de área.
 * A vitrine continua acessível mesmo quando ainda não há parceiros cadastrados.
 */
const ClientTabBar = ({ companyUuid, onBookingTab }) => {
    // A barra ocupa o rodapé: a página ganha espaço embaixo e o rodapé fixo do agendamento sobe.
    useEffect(() => {
        document.documentElement.classList.add('has-client-tabbar');
        return () => document.documentElement.classList.remove('has-client-tabbar');
    }, []);

    const tabs = [
        { to: `/booking/${companyUuid}`, icon: 'fa-solid fa-calendar-plus', label: 'Agendar', end: true, onClick: onBookingTab,
            // O fluxo de agendamento tem etapas na própria rota (/booking/:empresa/:etapa).
            isActive: (path) => path.startsWith(`/booking/${companyUuid}`) && !path.endsWith('/my-appointments') && !path.endsWith('/partners') },
        { to: `/booking/${companyUuid}/my-appointments`, icon: 'fa-solid fa-calendar-check', label: 'Meus agendamentos' },
        { to: `/booking/${companyUuid}/partners`, icon: 'fa-solid fa-gift', label: 'Parceiros' }
    ].filter(Boolean);

    return (
        <nav className="client-tabbar" aria-label="Navegação principal">
            {tabs.map((tab) => (
                <NavLink key={tab.to} to={tab.to}
                    onClick={tab.onClick ? (event) => { event.preventDefault(); tab.onClick(); } : undefined}
                    className={({ isActive }) => `client-tabbar__item ${(tab.isActive ? tab.isActive(window.location.pathname) : isActive) ? 'is-active' : ''}`}>
                    <i className={tab.icon}></i>
                    <span>{tab.label}</span>
                </NavLink>
            ))}
        </nav>
    );
};

export default ClientTabBar;
